/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { itemRefSchema } from './itemRefSchema';

export const paginatedResultItemRefSchema = z.object({
  cursor: z.string().nullish(),
  get data() {
    return z.array(itemRefSchema);
  },
  recordCount: z.int().nullish(),
  recordLimit: z.int().nullish(),
  totalCount: z.int().nullish(),
});
